import { loadStripe, StripeElementsOptionsMode } from '@stripe/stripe-js'
import { useMemo } from 'react'

import { Props as StripeSetupFormProps } from '@/components/checkout/stripe-setup-form'
import { StripeSetupFormWrapper } from '@/components/checkout/stripe-setup-form-wrapper'
import { env } from '@/env'
import { useStripeElementsDefaultOptions } from '@/lib/hooks/use-stripe-elements-default-options'

type Props = {
  options: StripeElementsOptionsMode
} & StripeSetupFormProps

export const StripeSetupWrapper = ({
  onSetupInitiated,
  onSetupConfirmed,
  getSetupParams,
  siteSlug,
  storeConfigData,
  options,
  defaultValues,
}: Props) => {
  const stripeAccountId = storeConfigData?.stripeLinkedAccount?.stripeAccountId

  const stripePromise = useMemo(() => {
    if (!stripeAccountId) {
      return null
    }

    return loadStripe(env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY, {
      stripeAccount: stripeAccountId,
    })
  }, [stripeAccountId])

  const elementsOptions = useStripeElementsDefaultOptions({
    ...options,
    mode: 'setup',
    setupFutureUsage: 'off_session',
    currency: options.currency,
    clientSecret: options.clientSecret,
  })

  return (
    <>
      <StripeSetupFormWrapper
        siteSlug={siteSlug}
        stripePromise={stripePromise}
        defaultValues={defaultValues}
        options={elementsOptions}
        getSetupParams={getSetupParams}
        onSetupInitiated={onSetupInitiated}
        onSetupConfirmed={onSetupConfirmed}
      />
    </>
  )
}
